import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Form, Button, Card, Space } from "antd";
import FormFields from "./FormFields";
import { addUser } from "../../../redux/slices/users/usersThunk";
import { fetchRoles } from "../../../redux/slices/roles/rolesThunk";

const AddUsersPage = () => {
  const [form] = Form.useForm();
  const history = useHistory();
  const dispatch = useDispatch();

  const { rolesList, status: rolesStatus } = useSelector((state) => state.roles);

  useEffect(() => {
    dispatch(fetchRoles());
  }, [dispatch]);

  const onFinish = (values) => {
    const formattedValues = {
      ...values,
      role: { id: values.role },
      status: { id: values.status ? 1 : 2 }, // Supposant 1=Actif, 2=Inactif
    };

    dispatch(addUser(formattedValues)).then((res) => {
      if (addUser.fulfilled.match(res)) {
        history.push("/utilisateurs");
      }
    });
  };

  return (
    <Card title="Ajouter un utilisateur">
      <Form form={form} onFinish={onFinish} labelCol={{ span: 8 }} wrapperCol={{ span: 12 }}>
        <FormFields roles={rolesList} isRolesLoading={rolesStatus === 'loading'} isEditing={false} />
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Space>
            <Button type="primary" htmlType="submit">
              Enregistrer
            </Button>
            <Button htmlType="button" onClick={() => form.resetFields()}>
              Réinitialiser
            </Button>
            <Button type="link" onClick={() => history.push("/utilisateurs")}>
              Annuler
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default AddUsersPage;